var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "v-details-inner-form" }, [
    _c("div", { staticClass: "form__heading" }, [
      _vm.familyTypeState == "living_together"
        ? _c("h2", { staticClass: "form__title" }, [
            _vm._v(_vm._s(_vm.partner))
          ])
        : _c("h2", { staticClass: "form__title" }, [
            _vm._v(_vm._s(_vm.subscriptions) + " " + _vm._s(_vm.i + 1))
          ])
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "form__list" }, [
      _c(
        "li",
        { staticClass: "form__item form__item--no-label" },
        [
          _c("v-radios-public", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|make_choice",
                expression: "`required|make_choice`"
              }
            ],
            attrs: {
              name: "person[" + [_vm.i] + "][title_id]",
              options: _vm.usersTitleOptions
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-radios-public", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "`required`"
              }
            ],
            attrs: {
              label:
                _vm.locales && _vm.locales.users && _vm.locales.users.language,
              value: _vm.defaultLanguage,
              name: "person[" + [_vm.i] + "][language]",
              "show-zero-option": "0",
              options: _vm.languages
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|alpha_spaces_dash",
                expression: "`required|alpha_spaces_dash`"
              }
            ],
            attrs: {
              label: _vm.usersFirstName,
              name: "person[" + [_vm.i] + "][first_name]"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            attrs: {
              label: _vm.usersMiddleName,
              name: "person[" + [_vm.i] + "][middle_name]"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|alpha_spaces_dash",
                expression: "`required|alpha_spaces_dash`"
              }
            ],
            attrs: {
              label: _vm.usersLastName,
              name: "person[" + [_vm.i] + "][last_name]"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            ref: "person_postcode_" + _vm.i,
            staticClass: "js-postcode",
            attrs: {
              name: "person[" + [_vm.i] + "][address][post_code]",
              label:
                _vm.locales && _vm.locales.users && _vm.locales.users.post_code
            },
            on: {
              blur: function($event) {
                return _vm.checkPcHn($event, _vm.i)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            ref: "person_housenumber_" + _vm.i,
            staticClass: "js-house-number",
            attrs: {
              name: "person[" + [_vm.i] + "][address][house_number]",
              label:
                _vm.locales &&
                _vm.locales.users &&
                _vm.locales.users.house_number
            },
            on: {
              blur: function($event) {
                return _vm.checkPostcodeAddress($event, _vm.i)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            ref: "person_street_" + _vm.i,
            attrs: {
              name: "person[" + [_vm.i] + "][address][street]",
              label:
                _vm.locales && _vm.locales.users && _vm.locales.users.street
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            ref: "person_city_" + _vm.i,
            attrs: {
              "is-update-model": true,
              name: "person[" + [_vm.i] + "][address][city]",
              label: _vm.locales && _vm.locales.users && _vm.locales.users.city
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-datepicker-public", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "`required`"
              }
            ],
            attrs: {
              label: _vm.usersDateOfBirth,
              name: "person[" + [_vm.i] + "][birthdate]"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|phone_number",
                expression: "`required|phone_number`"
              }
            ],
            staticClass: "js-unique-phone",
            attrs: {
              label: _vm.usersPhoneNumber,
              name: "person[" + [_vm.i] + "][phone_number]"
            },
            on: { blur: _vm.checkPhone }
          })
        ],
        1
      ),
      _vm._v(" "),
      !!_vm.is_phone_number_unique
        ? _c("li", { staticClass: "form__item" }, [
            _c("label", { staticClass: "form__label" }),
            _vm._v(" "),
            _c("b", { staticStyle: { color: "red" } }, [
              _vm._v(_vm._s(_vm.incomePhoneNumberAlreadyExists))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "`required`"
                }
              ],
              attrs: { type: "hidden", name: "phone_number_unique" }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-textfield-public", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|email",
                expression: "`required|email`"
              }
            ],
            staticClass: "js-unique-mail",
            attrs: {
              label: _vm.usersEmail,
              name: "person[" + [_vm.i] + "][email]",
              type: "email"
            },
            on: { blur: _vm.checkMail }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("label", { staticClass: "form__label" }),
      _vm._v(" "),
      _c("b", { staticStyle: { color: "red" } }, [
        _vm._v(_vm._s(_vm.incomeIsUserAlreadyExists))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "`required`"
          }
        ],
        attrs: { type: "hidden", name: "user_already_exists" }
      }),
      _vm._v(" "),
      _vm.is_user_already_exists == 2
        ? _c("li", { staticClass: "form__item" }, [
            _c("label", { staticClass: "form__label" }),
            _vm._v(" "),
            _c("b", { staticStyle: { color: "red" } }, [
              _vm._v(_vm._s(_vm.incomeIsUserBanned))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "`required`"
                }
              ],
              attrs: { type: "hidden", name: "user_already_exists" }
            })
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form__heading" }, [
      _vm.familyTypeState == "living_together"
        ? _c("h2", { staticClass: "form__title" }, [
            _vm._v(_vm._s(_vm.partner) + " " + _vm._s(_vm.incomeTitle))
          ])
        : _c("h2", { staticClass: "form__title" }, [
            _vm._v(
              _vm._s(_vm.subscriptions) +
                " " +
                _vm._s(_vm.i + 1) +
                " " +
                _vm._s(_vm.incomeTitle)
            )
          ])
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "form__list" },
      [
        _c(
          "li",
          { staticClass: "form__item" },
          [
            _c("v-checkboxes-public", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|make_choice",
                  expression: "`required|make_choice`"
                }
              ],
              attrs: {
                label: _vm.usersIAm,
                name: "person[" + [_vm.i] + "][type_of_income][]",
                options: _vm.usersTypeOfIncomeOptions
              },
              on: { input: _vm.triggerIncomeAdditionalForms }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.income_form_work_business
          ? [
              _vm.income_form_work
                ? _c(
                    "li",
                    { staticClass: "form__item" },
                    [
                      _c("v-radios-public", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|make_choice",
                            expression: "`required|make_choice`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersContractType,
                          name:
                            "person[" + [_vm.i] + "][working_contract_type_id]",
                          options: _vm.usersContractTypeOptions
                        },
                        on: { input: _vm.triggerContractDuration }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showDuration && _vm.income_form_work
                ? [
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|numeric",
                              expression: "`required|numeric`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersContractDuration,
                            name:
                              "person[" +
                              [_vm.i] +
                              "][working_contract_duration]"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-datepicker-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "`required`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersContractEndDate,
                            name:
                              "person[" +
                              [_vm.i] +
                              "][working_contract_end_date]"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: {
                      label: _vm.usersOccupation,
                      name: "person[" + [_vm.i] + "][occupation]"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|numeric",
                        expression: "`required|numeric`"
                      }
                    ],
                    attrs: {
                      label: _vm.usersMonthlyIncome,
                      name: "person[" + [_vm.i] + "][income]"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__bottom-row" }, [
                    _vm._v(_vm._s(_vm.usersMonthlyIncomeNote))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-radios-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      label: _vm.usersDoYouHaveGuarantorGeneral,
                      name: "person[" + [_vm.i] + "][guarantor]",
                      options: _vm.usersDoYouHaveGuarantorOptions,
                      value: "0"
                    },
                    on: { input: _vm.triggerGuarantorForm }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.guarantor_form_state == 1
                ? _c(
                    "li",
                    { staticClass: "form__item" },
                    [
                      _c("v-textfield-public", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric",
                            expression: "`required|numeric`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersGuarantorIncome,
                          name: "person[" + [_vm.i] + "][guarantor_income]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.income_form_studying
          ? [
              !_vm.income_form_work_business
                ? [
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-radios-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|make_choice",
                              expression: "`required|make_choice`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersDoYouHaveGuarantor,
                            name: "person[" + [_vm.i] + "][guarantor]",
                            options: _vm.usersDoYouHaveGuarantorOptions,
                            value: "0"
                          },
                          on: { input: _vm.triggerGuarantorForm }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.guarantor_form_state == 1
                      ? _c(
                          "li",
                          { staticClass: "form__item" },
                          [
                            _c("v-textfield-public", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "`required|numeric`"
                                }
                              ],
                              attrs: {
                                label: _vm.usersGuarantorIncome,
                                name:
                                  "person[" + [_vm.i] + "][guarantor_income]"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: {
                      label: _vm.usersStudy,
                      name: "person[" + [_vm.i] + "][study]"
                    }
                  })
                ],
                1
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.income_form_any
          ? _c("li", { staticClass: "form__item form__item--align-start" }, [
              _c("label", { staticClass: "form__label" }, [
                _vm._v(_vm._s(_vm.usersExtraInformationIncome))
              ]),
              _vm._v(" "),
              _c("textarea", {
                staticClass: "form__textarea",
                attrs: { name: "person[" + [_vm.i] + "][income_note]" }
              })
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form__heading" }, [
      _vm.familyTypeState == "living_together"
        ? _c("h2", { staticClass: "form__title" }, [
            _vm._v(
              _vm._s(_vm.partner) +
                " " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.users &&
                    _vm.locales.users.landlord_details.toLowerCase()
                )
            )
          ])
        : _c("h2", { staticClass: "form__title" }, [
            _vm._v(
              _vm._s(_vm.subscriptions) +
                " " +
                _vm._s(_vm.i + 1) +
                " " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.users &&
                    _vm.locales.users.landlord_details.toLowerCase()
                )
            )
          ])
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "form__list" }, [
      _c(
        "li",
        { staticClass: "form__item" },
        [
          _c("v-radios-public", {
            attrs: {
              label:
                _vm.locales &&
                _vm.locales.users &&
                _vm.locales.users.who_is_your_landlord,
              name: "person[" + [_vm.i] + "][landlord_status]",
              options: _vm.usersLandlordOptions
            },
            on: { input: _vm.triggerLandlordType }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.landlord_type_state == "renting_property"
        ? _c("li", { staticClass: "form__item" }, [
            _c("ul", { staticClass: "form__list" }, [
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    attrs: {
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.landlord_name,
                      name: "person[" + [_vm.i] + "][landlord_name]"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "email",
                        expression: "`email`"
                      }
                    ],
                    attrs: {
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.landlord_email,
                      name: "person[" + [_vm.i] + "][landlord_email]"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-textfield-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "phone_number",
                        expression: "`phone_number`"
                      }
                    ],
                    attrs: {
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.landlord_phone_number,
                      name: "person[" + [_vm.i] + "][landlord_phone_number]"
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5320824b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5320824b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VSubscribeInnerForm.vue
// module id = 443
// module chunks = 1